// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__11pVd","row":"Grid_row__2HmJB","start":"Grid_start__3kqML","col":"Grid_col__3sWWz","confirm":"Grid_confirm__XT1ls","buttons":"Grid_buttons__mRbOo"};